<template>
  <div class="main">
    <div :class="['address']" @click="changeAddress" v-if="pageType">
      <van-icon name="location" />
      <span class="address-title">{{ plazaName }}-{{ storeName }}</span>
      <van-icon name="arrow-down" />
    </div>
    <div class="insure" :style="{ backgroundImage: backgroundImage.main }">
      <div class="des" :style="{ backgroundImage: backgroundImage.main_top }">
        <img
          :src="
            pageType ? require('./img/font2.png') : require('./img/font1.png')
          "
        />
        <div v-if="!pageType">请完善资料，以免影响您在万达广场内的经营</div>
        <div v-if="pageType && must.length" style="width: 70%">
          <span v-for="item in must" :key="item.insuranceId"
            >【{{ item.insuranceName }}】</span
          >
          <span>为必须完善险</span>
        </div>
      </div>
      <div :class="['must', pageType ? 'aside-line' : '']" v-if="must.length">
        <img class="left-top" src="./img/left_top.png" v-if="pageType" />
        <InsureItem
          v-for="(item, index) in must"
          :item="item"
          :key="item.insuranceId"
          :index="index"
        />
      </div>
      <div class="notEssential" v-if="pageType">
        <InsureItem
          v-for="(item, index) in notEssential"
          :key="item.insuranceId"
          :item="item"
          :index="index"
        />
      </div>
    </div>
    <van-action-sheet
      v-model="actionSheetShow"
      title="门店选择"
      @cancel="actionSheetCancel"
    >
      <StoreChange @submit="handleSubmit" />
    </van-action-sheet>
  </div>
</template>
<script>
import InsureItem from './components/insure-item.vue';
import StoreChange from './store_change.vue';
import { ActionSheet, RadioGroup, Radio } from 'vant';
import * as types from '@/store/mutation-types';
import { ApiGetInsuranceList, apiGetStore } from '@/api/insurance';
const roleType = {
  0: '未绑定门店',
  1: '店长',
  2: '区经',
  3: '店员',
  4: '财务',
};

export default {
  components: {
    VanActionSheet: ActionSheet,
    InsureItem,
    StoreChange,
  },
  data() {
    return {
      roleType,
      backgroundImage: {
        main: 'url(' + require('./img/main.png') + ')',
        main_top: 'url(' + require('./img/main_top.png') + ')',
        btn: 'url(' + require('./img/button_bg.png') + ')',
      },
      actionSheetShow: false,
      radio: '',
      must: [],
      notEssential: [],
      storeList: [],
    };
  },
  computed: {
    insuranceId() {
      return this.$route.query.id;
    },
    userId() {
      return this.$store.state.account.userId;
    },
    plazaId() {
      return this.$store.state.account.plazaId;
    },
    plazaName() {
      return this.$store.state.account.plazaName;
    },
    storeId() {
      return this.$store.state.account.storeId;
    },
    storeName() {
      return this.$store.state.base.storeName;
    },
    bunkDesc() {
      return this.$store.state.base.bunkDesc;
    },
    pageType() {
      return this.$store.state.base.pageType;
    },
  },
  methods: {
    handleSubmit() {
      this.actionSheetShow = false;
      this.getInsureList();
    },
    getStoreList() {
      let userId = this.userId;
      // let userId = '1640218236';
      apiGetStore(userId).then((list) => {
        this.storeList = list;
      });
    },
    getInsureList() {
      let data = {
        plazaId: this.plazaId,
        storeId: this.storeId,
        insuranceId: this.insuranceId,
        source: this.pageType ? 1 : 0,
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });

      ApiGetInsuranceList(data).then((res) => {
        this.$toast.clear();
        this.must = res.must;
        this.notEssential = res.notEssential;
      });
    },
    changeAddress() {
      this.getStoreList();
      this.actionSheetShow = true;
    },
    handleRadioClick(value) {
      this.radio = value;
    },
    actionSheetCancel() {
      this.radio = '';
      this.actionSheetShow = false;
    },
  },
  mounted() {
    this.getInsureList();
  },
};
</script>

<style lang="less" scoped>
.main {
  overflow: auto;
  background: #f3f5f6;
  font-family: PingFangSC-Medium, PingFang SC;
  .address {
    text-align: left;
    font-size: 15px;
    font-weight: 500;
    color: #111111;
    line-height: 21px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    background: #fff;
    .van-icon {
      font-size: 13px;
      margin: 0 4px;
    }
    .address-title {
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
.insure {
  line-height: 1;
  font-size: 12px;
  text-align: left;
  background-repeat: no-repeat;
  // background-position: center;
  background-size: 100% 300px;
  padding: 12px 12px 30px 12px;
  box-sizing: border-box;
  background-color: #f3f5f6;
  overflow: auto;

  .des {
    font-size: 12px;
    font-weight: 400;
    color: #834639;
    padding: 18px 0;
    line-height: 18px;

    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 116px 87px;
    img {
      width: 96px;
      height: 25px;
      margin-bottom: 8px;
    }
  }
  .must {
    border-radius: 8px;
    margin-bottom: 15px;

    overflow: hidden;
    .firstCard {
      // background: linear-gradient(180deg, #ffede9 0%, #ffffff 100%);
      background-image: url('./img/card_bgi.png');
      background-position: left top;
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
  .notEssential {
    border-radius: 8px;
    overflow: hidden;
  }
  .aside-line {
    position: relative;
    border: 2px solid #fecac3;
    .left-top {
      position: absolute;
      width: 76px;
      height: 24px;
      left: 0;
      top: 0;
      z-index: 9;
    }
  }
}

.main {
  /deep/.van-action-sheet__header {
    color: #000000;
    width: 100%;
    position: relative;

    .van-action-sheet__close {
      position: absolute;
      display: inline-block;
      width: 20px;
      padding-top: 14px;
    }
  }
}
</style>